<template>
  <div class="design-radio-button-wrapper" :class="{ checked, small: size === 'small' }">
    <input type="radio" class="design-radio-button" v-model="checked" />
    <div class="design-radio-button-ripple" @click="checked = !checked"></div>
    <div class="design-radio-button-label" @click="checked = !checked">
      <label>{{ label }}</label>
    </div>
    <i v-if="checked" class="mdi mdi-radiobox-marked design-radio-button-icon"></i>
    <i v-else class="mdi mdi-radiobox-blank design-radio-button-icon"></i>
  </div>
</template>
<script>
export default {
  name: 'DesignRadioButton',
  props: {
    value: {
      type: [Boolean, String, Number],
      required: true
    },
    size: {
      type: String,
      required: false,
      default: ''
    },
    id: {
      type: [String, Boolean, Number],
      required: false
    },
    label: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      checked: false
    };
  },
  watch: {
    value() {
      this.checked = this.value === this.id;
    },
    checked(value) {
      if (value) {
        this.$emit('input', this.id);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.design-radio-button-wrapper {
  position: relative;
  height: 24px;
  margin-right: 6px;

  i {
    font-size: 24px;
  }

  .design-radio-button {
    -webkit-appearance: none; /* 웹킷 브라우저에서 기본 스타일 제거 */
    -moz-appearance: none; /* Firefox에서 기본 스타일 제거 */
    appearance: none; /* 표준화된 기본 스타일 제거 */
    position: absolute;
  }

  .design-radio-button-ripple {
    cursor: pointer;
    position: absolute;
    width: 24px;
    height: 24px;
  }

  .design-radio-button-label {
    cursor: pointer;
    position: absolute;
    left: 25px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    label {
      cursor: pointer;
      font-size: 14px;
      line-height: 20px;
      color: #676767;
    }
  }

  .design-radio-button-icon {
    color: #b9bbbe;
  }

  &.checked {
    .design-radio-button-icon {
      color: #5578f0;
    }
  }

  &.small {
    height: 20px;
    i {
      font-size: 20px;
    }

    .design-radio-button-ripple {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
